import Vue from 'vue'
import App from './App'
import router from './router/index.js'
import './assets/index.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'lib-flexible/flexible.js'
import './assets/rem'

Vue.use(Vant)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
